module.exports = __webpack_public_path__ + "img/friends.25b6e174.svg";